import { easeInSine, easeOutSine, Vector2 } from '@cgs/wge';
import { IReelsConfig } from '../i_reels_config';
import { Easing } from '../internal_reels_config';

export class FreeFallReelsConfig implements IReelsConfig {
  public slotSize: Vector2;
  public slotSizeByReel: Vector2[] | null = null;
  public symbolSize: Vector2;
  public symbolSizeByReel: Vector2[] | null = null;
  public reelCount: number;
  public lineCount: number;
  public reelsOffset: Vector2[];
  public offset: Vector2;
  public offsetByReel: Vector2[] | null = null;

  constructor(
    slotSize: Vector2,
    symbolSize: Vector2,
    reelCount: number,
    lineCount: number,
    reelsOffset: Vector2[],
    offset: Vector2
  ) {
    this.slotSize = slotSize;
    this.symbolSize = symbolSize;
    this.reelCount = reelCount;
    this.lineCount = lineCount;
    this.reelsOffset = reelsOffset;
    this.offset = offset;
  }

  public getStartEasing(_reelIndex: number): Easing {
    return easeOutSine;
  }

  public getStopEasing(_reelIndex: number): Easing {
    return easeInSine;
  }

  get iconsCount(): number {
    return this.reelCount * this.lineCount;
  }
}
